import { create } from "zustand";

type JobViewStore = {
  isAggregated: boolean;
  setIsAggregated: (isAggregated: boolean) => void;
};

export const useJobViewStore = create<JobViewStore>()((set) => ({
  isAggregated: true,
  setIsAggregated: (isAggregated: boolean) => set({ isAggregated }),
}));
